var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardTodoMoney({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.32312 10.7937C4.32312 11.4301 4.86048 11.946 5.52334 11.946H6.72357C7.38644 11.946 7.92379 11.4301 7.92379 10.7937C7.92379 10.1574 7.38644 9.64153 6.72357 9.64153H5.52334C4.86048 9.64153 4.32312 9.12566 4.32312 8.48931C4.32312 7.85296 4.86048 7.33709 5.52334 7.33709H6.72357C7.38644 7.33709 7.92379 7.85296 7.92379 8.48931M6.12346 6.76099V12.5221",
    stroke: "#6987B4",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.94874 1.19405V4.16859C7.94874 4.57191 7.94874 4.77356 8.02859 4.92761C8.09883 5.06311 8.2109 5.17328 8.34874 5.24232C8.50545 5.32081 8.71059 5.32081 9.12088 5.32081H12.1468M12.3442 6.7526V11.946C12.3442 13.156 12.3442 13.761 12.1047 14.2231C11.894 14.6296 11.5578 14.9601 11.1442 15.1672C10.6741 15.4027 10.0587 15.4027 8.82784 15.4027H4.13932C2.90847 15.4027 2.29304 15.4027 1.82291 15.1672C1.40938 14.9601 1.07317 14.6296 0.862465 14.2231C0.622925 13.761 0.622925 13.156 0.622925 11.946V4.45665C0.622925 3.24671 0.622925 2.64174 0.862465 2.1796C1.07317 1.7731 1.40938 1.4426 1.82291 1.23547C2.29304 1 2.90847 1 4.13932 1H6.49221C7.02975 1 7.29853 1 7.55146 1.05969C7.77571 1.11261 7.99009 1.1999 8.18673 1.31836C8.40852 1.45196 8.59857 1.63878 8.97867 2.01243L11.3143 4.30838C11.6944 4.68203 11.8845 4.86885 12.0204 5.08687C12.1409 5.28017 12.2297 5.4909 12.2835 5.71134C12.3442 5.95998 12.3442 6.22418 12.3442 6.7526Z",
    stroke: "#6987B4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardTodoMoney);
export default __webpack_public_path__ + "static/media/DashboardTodoMoney.8a540a19fc0ee12b830904c1fb7ad0de.svg";
export { ForwardRef as ReactComponent };